// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1gOCI","right":"styles_right__2h963"};